// Botones para descargar las HOJAS POR INTEGRANTE de un crédito grupal.
//
// - HojasIntegrantesButton: descarga el PDF concatenado (titular primero, salto de página
//   por integrante). Se muestra en el header de la tabla de integrantes en Cartera.jsx.
// - HojaIntegranteButton: descarga la hoja de UN integrante (por fila en la tabla).
//
// Ambos usan el token de auth en un fetch → blob para respetar el Bearer y evitar el
// pop-up bloqueado por navegadores cuando abres inline PDF sin credenciales. 100% aditivo.
import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { TooltipButton } from "@/components/common/Tooltips";
import { api } from "@/lib/api";
import { toast } from "sonner";

async function descargarPdf(path, nombreArchivo) {
  const res = await api.get(path, { responseType: "blob" });
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombreArchivo;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 400);
}

export function HojasIntegrantesButton({ credito }) {
  const [busy, setBusy] = useState(false);
  if (!credito?.integrantes?.length) return null;
  const onClick = async () => {
    setBusy(true);
    try {
      await descargarPdf(
        `/creditos/${credito.id}/hojas-integrantes`,
        `Hojas_Integrantes_${credito.numero_credito || credito.id}.pdf`
      );
      toast.success("Hojas por integrante descargadas");
    } catch (e) {
      toast.error("No se pudieron generar las hojas por integrante");
    } finally {
      setBusy(false);
    }
  };
  return (
    <TooltipButton
      tooltip="Descarga un PDF con la hoja por integrante (anexo contractual · titular primero · una hoja por integrante con firma)"
      size="sm"
      variant="outline"
      className="h-7"
      onClick={onClick}
      disabled={busy}
      data-testid="hojas-integrantes-btn"
    >
      {busy ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" />
            : <Download className="mr-1.5 h-3.5 w-3.5" />}
      Hojas por integrante
    </TooltipButton>
  );
}

export function HojaIntegranteButton({ credito, integrante }) {
  const [busy, setBusy] = useState(false);
  const onClick = async () => {
    setBusy(true);
    try {
      const nombreSlug = String(integrante.cliente || integrante.cliente_id)
        .replace(/\s+/g, "_")
        .slice(0, 40);
      await descargarPdf(
        `/creditos/${credito.id}/hoja-integrante/${integrante.cliente_id}`,
        `Hoja_${credito.numero_credito || credito.id}_${nombreSlug}.pdf`
      );
    } catch (e) {
      toast.error("No se pudo generar la hoja del integrante");
    } finally {
      setBusy(false);
    }
  };
  return (
    <TooltipButton
      tooltip="Descargar la hoja del integrante (PDF con datos, tabla y firma)"
      size="sm"
      variant="outline"
      className="h-7 px-2"
      onClick={onClick}
      disabled={busy}
      data-testid={`hoja-integrante-${integrante.cliente_id}`}
    >
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" />
            : <Download className="h-3.5 w-3.5" />}
    </TooltipButton>
  );
}
